/// <amd-module name="SuiteCommerce.CookieConsent.Overlay.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.Overlay.View", ["require", "exports", "Backbone", "suitecommerce_cookie_consent_overlay.tpl", "SuiteCommerce.CookieConsent.Overlay.Configuration", "underscore"], function (require, exports, Backbone_1, template, Overlay_Configuration_1, _) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.OverlayView = void 0;
    var OverlayView = /** @class */ (function (_super) {
        __extends(OverlayView, _super);
        function OverlayView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = template;
            _this.elementsToAlterFocusTabOrder = "\n       a, button, textarea,\n       input ,select, form\n      ";
            _this.application = options.container;
            _this.setThemeHeaderClass();
            _this.trapFocus();
            return _this;
        }
        OverlayView.prototype.setThemeHeaderClass = function () {
            // Workaround to fix header issue in Summit
            jQuery(function () {
                var isFixedHeaderEnabled = Overlay_Configuration_1.OverlayConfiguration.isFixedHeaderEnabled;
                var header = jQuery('.shopping-layout-header, .myaccount-layout-header,.checkout-layout-header');
                if (header.hasClass('cookieconsent-overlay-banner-open')) {
                    header.removeClass('cookieconsent-overlay-banner-open');
                }
                else if (!_.isUndefined(isFixedHeaderEnabled)) {
                    header.addClass('cookieconsent-overlay-banner-open');
                }
            });
        };
        OverlayView.prototype.removeTrapFocus = function () {
            var cookieConsentFocusableElements = jQuery('#cookieconsent-container').find(this.elementsToAlterFocusTabOrder);
            var documentFocusableElements = jQuery(document).find(this.elementsToAlterFocusTabOrder);
            if (cookieConsentFocusableElements && documentFocusableElements) {
                documentFocusableElements.removeAttr('disabled');
                documentFocusableElements.removeAttr('tabindex');
                documentFocusableElements.removeAttr('aria-hidden');
                cookieConsentFocusableElements.attr('disabled', 'true');
                cookieConsentFocusableElements.attr('tabindex', '-1');
                cookieConsentFocusableElements.attr('aria-hidden', 'true');
            }
        };
        OverlayView.prototype.enableFocusOnModal = function () {
            var modalFocusableElements = jQuery('#cookieconsentModal').find(this.elementsToAlterFocusTabOrder);
            modalFocusableElements.removeAttr('disabled');
            modalFocusableElements.removeAttr('tabindex');
            modalFocusableElements.removeAttr('aria-hidden');
        };
        OverlayView.prototype.hideOverlayBanner = function () {
            jQuery('#cookieconsent-banner').addClass('cookieconsent-overlay-banner-hide');
        };
        OverlayView.prototype.closeOverlay = function () {
            var layout = this.application.getComponent('Layout');
            this.removeTrapFocus();
            this.setThemeHeaderClass();
            layout.removeChildView('cookieConsent-overlay');
        };
        OverlayView.prototype.getContext = function () {
            return {
                bannerHeading: Overlay_Configuration_1.OverlayConfiguration.bannerHeading,
                bannerText: Overlay_Configuration_1.OverlayConfiguration.bannerText,
                overlayColor: Overlay_Configuration_1.OverlayConfiguration.overlayColor,
                bannerPosition: Overlay_Configuration_1.OverlayConfiguration.bannerPosition
            };
        };
        OverlayView.prototype.trapFocus = function () {
            var _this = this;
            $(function () {
                var cookieConsentFocusableElements = jQuery('#cookieconsent-container').find(_this.elementsToAlterFocusTabOrder);
                var documentFocusableElements = jQuery(document).find(_this.elementsToAlterFocusTabOrder);
                if (cookieConsentFocusableElements && documentFocusableElements) {
                    documentFocusableElements.attr('disabled', 'true');
                    documentFocusableElements.attr('aria-hidden', 'true');
                    documentFocusableElements.attr('tabindex', '-1');
                    cookieConsentFocusableElements.removeAttr('disabled');
                    cookieConsentFocusableElements.removeAttr('tabindex');
                    cookieConsentFocusableElements.removeAttr('aria-hidden');
                }
            });
        };
        return OverlayView;
    }(Backbone_1.View));
    exports.OverlayView = OverlayView;
});
